import { ApiCacheTags } from '@qapline/api';

export const cashflowTag = { type: ApiCacheTags.cashflow.dashboard } as const;
export const cashflowSourceTags = [
    cashflowTag,
    { type: ApiCacheTags.commission.list },
    { type: ApiCacheTags.invoice.list },
    { type: ApiCacheTags.expense.list },
    { type: ApiCacheTags.attachment.list },
];
